import * as React from 'react';
import { RegionCard } from '@ui/components';

import './RegionsList.less';

interface Props {
  regions: any[];
  onClick: (region: any) => void;
}

const RegionsList: React.FunctionComponent<Props> = ({ regions, onClick }) => (
  <div className="regions-list">
    {regions.map(region => (
      <RegionCard key={region.id} region={region} onClick={onClick} />
    ))}
  </div>
);

export default RegionsList;



// WEBPACK FOOTER //
// ./src/scenes/Regions/components/RegionsList/RegionsList.tsx